import { render, staticRenderFns } from "./AppraisalChip.vue?vue&type=template&id=393d1798&scoped=true"
import script from "./AppraisalChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppraisalChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppraisalChip.vue?vue&type=style&index=0&id=393d1798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d1798",
  null
  
)

export default component.exports